import { BackupDataStep } from "./BackupDataStep";
import { UploadCSV } from "./UploadCSV";
import { ShowResults } from "./ShowResults";
import { TrackProcess } from "./TrackProcess";
import { BulkAddStep } from "../BulkAddDialogTypes";

/**
 * Defines the steps (in order) the bulk add/update operation has
 */
export const BULK_ADD_STEPS: BulkAddStep[] = [
  {
    label: "Back up your data",
    StepComponent: BackupDataStep,
  },
  {
    label: "Select your CSV",
    StepComponent: UploadCSV,
  },
  {
    label: "Processing",
    StepComponent: TrackProcess,
  },
  {
    label: "Results",
    dialogWidth: "sm",
    StepComponent: ShowResults,
  },
];
